<template>
  <b-container class="planejamento">
    <h2>Planejamento da Saúde</h2>
    <div class="planejamento-body">
      <div class="planejamento-list" v-loading="loading">
        <ul>
          <li
            :class="{
              'planejamento-list__item': true,
              active: isActive(`${planeja.id}`),
            }"
            v-for="planeja in planejamento"
            :key="planeja.id"
          >
            <a
              :class="{
                'planejamento-list__item-link': true,
                active: isActive(`${planeja.id}`),
              }"
              @click.prevent="setActive(`${planeja.id}`)"
              :href="`#${planeja.titulo}`"
              >{{ planeja.titulo }}</a
            >
          </li>
        </ul>
      </div>
      <div
        class="planejamento-component"
        v-loading="loadingActive"
        v-if="!loading"
      >
        <ul v-if="planejaActive && planejaActive.length">
          <li v-for="data in planejaActive" :key="data.id">
            <a :href="data.arquivo" target="_blank">{{ data.titulo }}</a>
          </li>
        </ul>
        <span v-else-if="!loadingActive && !loading"
          >Não foram encontrados resultados para essa busca.</span
        >
      </div>
    </div>
  </b-container>
</template>

<script>
export default {
  name: "planejamento",
  data() {
    return {
      loading: false,
      loadingActive: false,
      planejamento: [],
      planejaActive: [],
      activeItem: "",
    };
  },
  methods: {
    async getPlanejamento() {
      this.loading = true;
      this.planejamento = [];
      const res = await this.$axios.get(`planejamento-saude`).catch((e) => {
        console.error("Planejamento", e);
      });
      if (res.status === 200) {
        this.planejamento = res.data;
        this.setActive(this.planejamento[0].id);
      }
      this.loading = false;
    },
    async getPlanejamentoActive(id) {
      this.loadingActive = true;
      const res = await this.$axios
        .get(`planejamento-saude/${id}`)
        .catch((e) => {
          console.error("Planejamento", e);
        });
      if (res.status === 200) {
        this.planejaActive = res.data;
      }
      this.loadingActive = false;
    },

    isActive(menuItem) {
      return this.activeItem.toString() === menuItem.toString();
    },
    setActive(menuItem) {
      this.activeItem = menuItem;
      this.getPlanejamentoActive(menuItem);
    },
  },
  created() {
    this.getPlanejamento();
  },
};
</script>

<style lang="scss">
.planejamento {
  &.container {
    padding: 30px 20px;
    text-align: left;
  }
  font-family: Poppins;
  // font-size: 14px;
  font-size: var(--font-size--default);
  h4,
  h2 {
    color: var(--color-text-title);
    font-weight: bold;
    text-align: left;
  }

  &-body {
    display: flex;
  }

  &-list {
    ul {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        background: var(--background-color-secondary);
        padding: 20px;
        border-radius: 0;
        margin: 0 1px 0 0;
        font-style: normal;
        font-weight: 400;
        border-top: 1px solid #dddddd;
        width: 300px;

        &:first-child {
          border-top: none;
        }
        & a {
          color: #87a8cc;
          &.active {
            color: #1f387f;
          }
        }

        &.active {
          background: #87a8cc;
        }
      }
    }
  }

  &-component {
    padding: 0 20px;
    width: 100%;
    ul {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        border-top: 1px solid #dddddd;
        padding: 10px 0;
        text-align: justify;
        &:first-child {
          border-top: none;
        }
        span {
          color: #007bff;
          text-decoration: none;
          background-color: transparent;
          cursor: pointer;
          &:hover {
            color: #0056b3;
            text-decoration: underline;
          }
        }
      }
    }
    .pg {
      ul {
        li {
          border: none;
        }
      }
    }
  }
}
.custom-content {
  ul {
    list-style: none;
    padding: 0 10px;
    margin: 0;
    li {
      padding: 10px;
    }
  }
}

@media only screen and (max-width: 720px) {
  .planejamento {
    &.container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    &-body {
      flex-direction: column-reverse;
      align-items: center;
    }
  }
}
</style>
